<template>
    <div>
        <div name="breadcrumb-layout" class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>设备运行情况</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <swb-query-sort-area name="query-sort-area" ref="query_sort_area" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :queryHandler="queryHandler" :onConfigReady="onConfigReady"></swb-query-sort-area>
        <div name="tabs" class="tab-container small base">
            <div class="tabs-nav">
                <ul class="head">
                    <li :class="{'current': status.value == checkStateValue}" class="head-item" v-for="status in tableState" @click="handleTabClick(status.value)">
                        <span>{{status.text}}</span>
                    </li>
                </ul>
            </div>
        </div>
        <div name="device-list">
            <div v-if="checkStateValue == 0">
                <swb-device-run-merchant-statis-list v-if="querySortArea != null" :queryModel="queryModel" :querySortArea="querySortArea" ref="swb_device_run_merchant_statis_list" :domHeight="domHeight"></swb-device-run-merchant-statis-list>
            </div>
            <div v-else>
                <swb-device-run-com-statis-list v-if="querySortArea != null" :queryModel="queryModel" :querySortArea="querySortArea" ref="swb_device_run_com_statis_list" :domHeight="domHeight"></swb-device-run-com-statis-list>
            </div>
        </div>
    </div>
</template>
<script>

    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher } from '../../app.vues'

    import { setAssetsGroupDevcFilter } from '../asset/selectDlg'
    import { loadAssetKindList, loadRetailerDevcGroupCascList, loadRetailerShopTagList } from '../retailer/asset-comn'

    import SwbDeviceRunMerchantStaticList from './DeviceRunMerchantStaticList';
    Vue.regist(SwbDeviceRunMerchantStaticList);

    import SwbDeviceRunComStaticList from './DeviceRunComStaticList'
    Vue.regist(SwbDeviceRunComStaticList);

    import retailerApi from '../../api/retailer'
    import userApi from '../../api/user'

    export default {
        name: 'swb-shop-device-maintain-statis-list',
        path: '/shop/device/maintain/statis/list',
        avlActions: '',
        avlScopes: 'retailer',
        desc: '设备运行情况',
        data: function () {
            return {
                confKey: 'swb-device-run-merchant-statis-list',
                merchtConfKey: 'swb-device-run-merchant-statis-list',
                shopConfKey: 'swb-device-run-com-statis-list',
                queryOnLoad: true,
                tableState: null,
                checkStateValue: 0,
                //
                queryModel: null,
                //
                domHeight: 300,
                querySortArea: null
            }
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            thisEl.addClass("overFlow-hidden");
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name = "device-list"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.domHeight = height;
                console.log("qw1" + height);
            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="breadcrumb-layout"], [name = "query-sort-area"], [name="tabs"]'));
            domSizeWatcher.start(500);
            //
            self.initResultTable();
        },
        beforeDestroy() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        created: function () {
            this.tableState = [{
                "text": "商户设备运行情况",
                "value": 0,
            }, {
                "text": "机构设备运行情况",
                "value": 1,
            }];
            //
            this.checkShopFlag();
        },
        methods: {
            initResultTable(){
                //
                let query_sort_area = this.$refs['query_sort_area'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                this.querySortArea = query_sort_area; // query_sort_area.getResultColConfRef();
            },
            checkShopFlag() {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == 'info') {
                        self.shopFlag = result.data.scopeEntity.shopFlag;
                    }
                });
            },
            handleTabClick(val) {
                this.checkStateValue = val;
                if(val == 0) {
                    this.confKey = this.merchtConfKey;
                } else {
                    this.confKey = this.shopConfKey;
                }
                //
                this.querySortArea = this.$refs['query_sort_area'];
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
            },
            onConfigReady(){
                let self = this;
                // 门店标签
                if(this.checkStateValue == 1) {
                    loadRetailerShopTagList(function (dataList) {
                        if((!Utils.isNoB(self.shopFlag) && Utils.isTrue(self.shopFlag)) || dataList.length <= 0) {
                            let query_model_ctrl = this.$refs['query_sort_area'];
                            query_model_ctrl.updateFields({
                                retailerShopTagId: {
                                    hidden: true
                                }
                            });
                        } else {
                            self.updateQueryModelField("retailerShopTagId", dataList);
                        }
                    });
                }
                // 分类分组
                loadRetailerDevcGroupCascList(function (dataList) {
                    self.updateQueryModelField("devcGroupId", dataList);
                });
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_sort_area'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/compo/statisWork/ShopDeviceMaintainStatisList.vue